<template>
  <div class="IndexContainer">
    <!-- 顶部 Banner -->
    <div class="banner-wrapper">
      <!-- 用户信息栏 -->
      <div class="user-bar" @click="$router.push('/my')">
        <img class="user-avatar" :src="user.avatar || defaultAvatar" />
        <span class="user-name">{{ user.nickName ? '你好！' + desensitize.desensitizeChineseName(user.nickName) : '点击登录' }}</span>
        <img class="user-arrow" src="../assets/image/right_icon.png" />
      </div>
      <img class="banner-img" src="../assets/image/banner.png" />
    </div>

    <!-- 便民服务标题 -->
    <div class="service-header">
      <img class="service-header-img" src="../assets/image/service_header.png" />
    </div>

    <!-- 服务卡片网格 -->
    <div class="service-grid">
      <div class="service-row">
        <div class="service-card" @click="goToView('/visit')">
          <img class="card-img" src="../assets/image/card_visit.png" />
        </div>
        <div class="service-card" @click="goToView('/train')">
          <img class="card-img" src="../assets/image/card_train.png" />
        </div>
      </div>
      <div class="service-row">
        <div class="service-card" @click="goToView('/drill')">
          <img class="card-img" src="../assets/image/card_drill.png" />
        </div>
        <div class="service-card" @click="goToView('/study')">
          <img class="card-img" src="../assets/image/card_study.png" />
        </div>
      </div>
      <div class="service-row">
        <div class="service-card half" @click="goToView('/consult')">
          <img class="card-img" src="../assets/image/card_business.png" />
        </div>
      </div>
    </div>

    <!-- 底部信息 -->
    <div class="footer-wrapper">
<!--      <img class="footer-img" src="../assets/image/footer.png" />-->
      <nut-row class="colFlex mt12 smallFont bothCenter" style="color:gray">
        <div class="colFlex bothCenter">
          <span>本服务由浙江政务服务网、杭州市消防救援支队提供</span>
        </div>
        <span>咨询服务热线:&nbsp;<span @click="call('0571-89580761')">0571-89580761</span></span>
      </nut-row>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import {Dialog} from "@nutui/nutui";
import desensitize from "../utils/desensitize";
import zwlogger from "@/utils/zwlogger";
import defaultAvatar from "../assets/default-avatar.png";
import {callPhone} from "@/utils/zlbutil"
export default {
  name: "IndexView",
  computed: {
    desensitize() {
      return desensitize
    }
  },
  data() {
    return {
      needAsk: false,
      user: {},
      defaultAvatar,
    }
  },
  methods: {
    call(p) {
      callPhone(p);
    },
    goToView(url) {
      if (this.needAsk) {
        Dialog({
          title: '知晓率问卷',
          content: '花您2分钟时间回答消防安全知晓率问卷。谢谢参与！',
          okText: '去回答',
          noCancelBtn: true,
          onCancel: () => {
          },
          onOk: () => {
            this.$router.push('/ask')
          }
        });
      } else {
        this.$router.push(url)
      }
    },
  },
  mounted() {
    if (this.$store.state.accessToken) {
      api.getUserInfo().then(ret => {
        this.user = ret;
      }).catch(() => {});
      api.isNeedAskPaper().then(ret => {
        this.needAsk = ret;
      }).catch(() => {});
    }
    zwlogger.sendPv('IndexView', '首页')
  }
}
</script>

<style scoped lang="scss">
.IndexContainer {
  background-color: #f0f4ff;
  min-height: 100vh;
  padding-bottom: 20px;

  .banner-wrapper {
    position: relative;
    padding: 0 16px;
    padding-top: 12px;

    .user-bar {
      position: absolute;
      top: 20px;
      left: 28px;
      z-index: 10;
      display: inline-flex;
      align-items: center;
      padding: 6px 14px 6px 6px;
      background: linear-gradient(to bottom, #EEDEE3, #d0d0ea);
      border-radius: 20px;
      cursor: pointer;

      .user-avatar {
        width: 28px;
        height: 28px;
        border-radius: 14px;
        box-shadow: 0px 2px 24px 0px rgba(222, 237, 255, 0.8);
      }

      .user-name {
        font-size: 14px;
        color: #001734;
        margin-left: 6px;
        white-space: nowrap;
      }

      .user-arrow {
        width: 14px;
        height: 14px;
        margin-left: 4px;
      }
    }

    .banner-img {
      width: 100%;
      border-radius: 16px;
      display: block;
    }
  }

  .service-header {
    padding: 10px 0;

    .service-header-img {
      width: 100%;
      display: block;
    }
  }

  .service-grid {
    padding: 0 16px 0;

    .service-row {
      display: flex;
      gap: 12px;
      margin-bottom: 12px;

      .service-card {
        flex: 1;
        min-width: 0;
        cursor: pointer;
        //border-radius: 16px;
        overflow: hidden;
        //background: #fff;

        &.half {
          flex: 0 0 calc(50% - 6px);
        }

        .card-img {
          width: 100%;
          display: block;
          border-radius: 16px;
        }
      }
    }
  }

  .footer-wrapper {
    padding: 16px 16px 0;

    .footer-img {
      width: 100%;
      display: block;
      border-radius: 16px;
    }
  }
}
</style>
